import React from 'react';

import type { PsychToolPageProps } from './PsychToolPageBase';
import PsychAboPage from './PsychAboPage';
import PsychBeautyPage from './PsychBeautyPage';
import PsychBipolarPage from './PsychBipolarPage';
import PsychCityPage from './PsychCityPage';
import PsychDarkPage from './PsychDarkPage';
import PsychEnneagramPage from './PsychEnneagramPage';
import PsychMbtiPage from './PsychMbtiPage';
import PsychMbtiStagePage from './PsychMbtiStagePage';
import PsychNeedsPage from './PsychNeedsPage';
import PsychPreferencePage from './PsychPreferencePage';
import PsychQuirkPage from './PsychQuirkPage';
import PsychRolePage from './PsychRolePage';
import PsychScl90Page from './PsychScl90Page';
import PsychSbtiPage from './PsychSbtiPage';
import PsychSexRepressPage from './PsychSexRepressPage';
import PsychTalentPage from './PsychTalentPage';

export const PSYCH_TOOL_PAGE_MAP: Record<string, React.ComponentType<PsychToolPageProps>> = {
  psychMbti: PsychMbtiPage,
  psychMbtiStage: PsychMbtiStagePage,
  psychBeauty: PsychBeautyPage,
  psychScl90: PsychScl90Page,
  psychBipolar: PsychBipolarPage,
  psychSexRepress: PsychSexRepressPage,
  psychQuirk: PsychQuirkPage,
  psychPreference: PsychPreferencePage,
  psychRole: PsychRolePage,
  psychAbo: PsychAboPage,
  psychDark: PsychDarkPage,
  psychTalent: PsychTalentPage,
  psychNeeds: PsychNeedsPage,
  psychCity: PsychCityPage,
  psychEnneagram: PsychEnneagramPage,
  psychSbti: PsychSbtiPage,
};
